import LogicFlow, { BezierEdge, BezierEdgeModel, h, PolylineEdge, PolylineEdgeModel } from '@logicflow/core';

class CustomEdge2 extends BezierEdge {
  // 重写getEndArrow方法，返回null移除箭头
  getEndArrow() {
    return null;
  }
  
  // 重写getStartArrow方法，返回null移除箭头
  getStartArrow() {
    return null;
  }

  // 选中时在边的中点渲染×删除按钮
  getAppendShape() {
    const { model } = this.props as any;
    if (!model.isSelected) return null;

    const { startPoint, endPoint } = model;
    const midX = (startPoint.x + endPoint.x) / 2;
    const midY = (startPoint.y + endPoint.y) / 2;
    const r = 9;

    return h('g', {
      onClick: (e: MouseEvent) => {
        e.stopPropagation();
        model.graphModel.deleteEdgeById(model.id);
      },
      style: { cursor: 'pointer' },
    }, [
      // 红色圆形背景
      h('circle', {
        cx: midX,
        cy: midY,
        r,
        fill: '#ff4d4f',
        stroke: '#fff',
        strokeWidth: 1.5,
      }),
      // × 图标
      h('text', {
        x: midX,
        y: midY,
        'text-anchor': 'middle',
        'dominant-baseline': 'central',
        fill: '#fff',
        'font-size': 14,
        'font-weight': 'bold',
        style: { userSelect: 'none', pointerEvents: 'none' },
      }, '×'),
    ]);
  }
}

class CustomEdgeModel2 extends BezierEdgeModel {
  // 贝塞尔边的样式逻辑
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    // 优先使用properties中的样式，如果没有则使用默认样式
    const { stroke = '#ababac', strokeWidth = 1.5, strokeDasharray = 'none' } = this.properties;
    style.stroke = stroke;
    style.strokeWidth = strokeWidth;
    style.strokeDasharray = strokeDasharray;
    return style;
  }

  // 保存锚点数据（原有逻辑保留）
  getData() {
    const data = super.getData();
    data.sourceAnchorId = this.sourceAnchorId;
    data.targetAnchorId = this.targetAnchorId;
    return data;
  }

  // 基于锚点更新路径（原有逻辑保留）
  updatePathByAnchor() {
    const sourceNodeModel = this.graphModel.getNodeModelById(this.sourceNodeId);
    const sourceAnchor = sourceNodeModel?.getDefaultAnchor()?.find(anchor => anchor?.id === this.sourceAnchorId);
    const targetNodeModel = this.graphModel.getNodeModelById(this.targetNodeId);
    const targetAnchor = targetNodeModel?.getDefaultAnchor()?.find(anchor => anchor?.id === this.targetAnchorId);

    if (sourceAnchor) this.updateStartPoint({ x: sourceAnchor.x, y: sourceAnchor.y });
    if (targetAnchor) this.updateEndPoint({ x: targetAnchor.x, y: targetAnchor.y });
    this.initPoints();
  }

  // 复用默认贝塞尔曲线逻辑（原有逻辑保留）
  initPoints() {
    super.initPoints();
  }
}

// 贝塞尔边配置项
export const BezierEdgeConfig = {
  type: 'sql-edge-bezier', // 唯一类型标识（区别于折线边）
  view: CustomEdge2,
  model: CustomEdgeModel2
};

// -------------------------- 2. 折线边配置（CustomPolyline + CustomPolylineModel）--------------------------
class CustomPolyline extends PolylineEdge {
  // 折线边的箭头逻辑（原有逻辑保留）
  getEndArrow() {
    const { model } = this.props;
    const { properties: { arrowType } } = model;
    const { stroke, strokeWidth } = model.getArrowStyle();
    const pathAttr = { stroke, strokeWidth };

    if (arrowType === 'empty') {
      return h('path', { ...pathAttr, fill: '#FFF', d: 'M -10 0  -20 -5 -30 0 -20 5 z' });
    } else if (arrowType === 'half') {
      return h('path', { ...pathAttr, d: 'M 0 0 -10 5' });
    }
    return h('path', { ...pathAttr, fill: stroke, d: 'M 0 0 -10 -5 -10 5 z' });
  }
}

class CustomPolylineModel extends PolylineEdgeModel {
  // 折线边的初始化（原有逻辑保留）
  initEdgeData(data: LogicFlow.EdgeConfig) {
    super.initEdgeData(data);
    this.customTextPosition = true;
  }

  // 折线边的文本位置（原有逻辑保留）
  getTextPosition(): LogicFlow.Point {
    const { textPosition = 'center' } = this.properties;
    const position = super.getTextPosition();
    const pointsList = this.points.split(' ').map(item => {
      const [x, y] = item.split(',');
      return { x: Number(x), y: Number(y) };
    });

    if (textPosition === 'start' && pointsList.length > 1) {
      const { x: x1, y: y1 } = pointsList[0];
      const { x: x2 } = pointsList[1];
      const distance = x2 < x1 ? -50 : 50;
      return { x: x1 + distance, y: y1 - 10 };
    } else if (textPosition === 'end' && pointsList.length > 1) {
      const { x: x1, y: y1 } = pointsList[pointsList.length - 2];
      const { x: x2, y: y2 } = pointsList[pointsList.length - 1];
      const distance = x2 < x1 ? -50 : 50;
      return { x: x2 - distance, y: y2 - 10 };
    }
    return position;
  }

  // 折线边的动画（原有逻辑保留）
  setAttributes() {
    this.isAnimation = !!this.properties.openAnimation;
  }

  getEdgeAnimationStyle() {
    const style = super.getEdgeAnimationStyle();
    // style.strokeDasharray = '15 5';
    style.animationDuration = '10s';
    style.stroke = 'rgb(130, 179, 102)';
    style.strokeDasharray = 'none';
    return style;
  }

  // 折线边的样式
  getEdgeStyle() {
    const style = super.getEdgeStyle();
    // 优先使用properties中的样式，如果没有则使用默认样式
    const { 
      stroke = '#ababac', 
      strokeWidth = 1, 
      strokeDasharray = 'none',
      edgeWeight = false, 
      highlight = false 
    } = this.properties;
    
    // 根据条件调整样式
    const finalStrokeWidth = highlight ? 5 : (edgeWeight ? 5 : strokeWidth);
    const finalStroke = highlight ? 'red' : stroke;
    
    style.stroke = finalStroke;
    style.strokeWidth = finalStrokeWidth;
    style.strokeDasharray = strokeDasharray;
    return style;
  }
}

// 折线边配置项
export const PolylineEdgeConfig = {
  type: 'sql-edge-polyline', // 唯一类型标识（区别于贝塞尔边）
  view: CustomPolyline,
  model: CustomPolylineModel
};

export const getDynamicEdgeType = (
  sourceNode: LogicFlow.NodeConfig, 
  targetNode: LogicFlow.NodeConfig
): string => {
  // 安全获取节点的 isItOntology 属性（避免 undefined 报错）
  const sourceIsOntology = sourceNode?.properties?.isItOntology || false;
  const targetIsOntology = targetNode?.properties?.isItOntology || false;
  console.log('getDynamicEdgeType', sourceIsOntology, targetIsOntology);
  
  // 判定条件：两个节点都不是“本体对象”
  const isTableToTable = !sourceIsOntology && !targetIsOntology;
  
  return isTableToTable ? BezierEdgeConfig.type : PolylineEdgeConfig.type;
};